import {Bell,ChevronRight,MessageCircle} from "lucide-react";
import {useQuery} from "@tanstack/react-query";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {api} from "../api";
import {useLocale} from "../App";
import type {Conversation,Woman} from "../types";
import {BottomNav,OnlineDot,PhoneShell} from "../components/Shell";

function timeLabel(value:string|null,lang:string){if(!value)return "";const date=new Date(value);const now=new Date();if(date.toDateString()===now.toDateString())return new Intl.DateTimeFormat(lang,{hour:"2-digit",minute:"2-digit"}).format(date);return new Intl.DateTimeFormat(lang,{weekday:"short"}).format(date);}

export function MessagesPage(){
  const lang=useLocale();
  const {t}=useTranslation();
  const navigate=useNavigate();
  const [unreadOnly,setUnreadOnly]=useState(false);
  const conversations=useQuery({queryKey:["conversations",lang],queryFn:()=>api<{conversations:Conversation[]}>(`/conversations?lang=${lang}`),refetchInterval:5000});
  const likes=useQuery({queryKey:["likes",lang],queryFn:()=>api<{women:Woman[]}>(`/likes?lang=${lang}`)});
  const allConversations=conversations.data?.conversations??[];
  const visibleConversations=unreadOnly?allConversations.filter((item)=>item.unread>0):allConversations;

  return <PhoneShell className="messages-page">
    <header className="messages-header">
      <div><h1>{t("messages")}</h1>{unreadOnly?<small>{t("unreadOnly")}</small>:null}</div>
      <button className={`messages-filter${unreadOnly?" active":""}`} type="button" aria-label={unreadOnly?t("showAllMessages"):t("unreadOnly")} aria-pressed={unreadOnly} onClick={()=>setUnreadOnly((current)=>!current)}><Bell/></button>
    </header>
    <div className="messages-scroll">
      <section className="new-matches">
        <div className="section-title"><h2>{t("newMatches")}</h2><button className="section-more" type="button" aria-label={t("viewAllMatches")} onClick={()=>navigate(`/${lang}/likes`)}><ChevronRight/></button></div>
        <div>{likes.data?.women.slice(0,6).map(woman=><button key={woman.id} onClick={()=>navigate(`/${lang}/women/${woman.id}`)}><span><img src={woman.photos[0]?.url??""} alt=""/><OnlineDot/></span><small>{woman.name}</small></button>)}</div>
      </section>
      {visibleConversations.length?<section className="conversation-list">{visibleConversations.map(item=><button key={item.id} onClick={()=>navigate(`/${lang}/chat/${item.id}`)}><span className="list-avatar"><img src={item.avatar_url} alt=""/><OnlineDot/></span><span className="list-copy"><b>{item.name}</b><small>{item.last_message??t("startConversation")}</small></span><span className="list-meta"><time>{timeLabel(item.last_message_at,lang)}</time>{item.unread>0&&<i>{item.unread>99?"99+":item.unread}</i>}</span></button>)}</section>:<div className="empty-state compact"><MessageCircle/><h2>{unreadOnly?t("noUnreadMessages"):t("emptyMessages")}</h2></div>}
    </div>
    <BottomNav/>
  </PhoneShell>;
}
